import { Tab } from 'react-dsgov';
import { IOperacao } from '../../../../../interfaces/IOperacaoPLG';
import { LavraGarimpeiraTab } from './components/lavraGarimpeiraTab/lavraGarimpeiraTab';
import { OutrosRegimesTab } from './components/outrosRegimesTab/outrosRegimesTab';
import styles from './titularArrendatarioListaProcessos.module.scss';
import { useContext, useEffect, useState } from 'react';
import titularArrendatarioEstadoProcesso, {
  ETabTitularArrendatario,
  IEstadoTitularArrendatario,
} from '../../../lib/titularArrendatarioEstadoProcesso';
import AnmNotificacaoContainer from '../../../../../components/anmNotificacao/anmNotificacaoContainer';
import { DiefCfemContext } from '../../../../../contexts/DiefCfemContext';
import { useBackEndRequests } from '../../../lib/backEndRequests';
import { listarErrosValidacao } from '../../../../../utils/formatErrosValidacao';

interface ITitularArrendatarioListaProcessosProps {
  setNovaOperacaoPLG: React.Dispatch<React.SetStateAction<boolean>>;
  setEdicaoOperacao: React.Dispatch<React.SetStateAction<IOperacao | undefined>>;
  setIsEdicaoOutrosRegimes: React.Dispatch<React.SetStateAction<boolean>>;
  estadoTela: IEstadoTitularArrendatario | null;
  setEstadoTela: React.Dispatch<React.SetStateAction<IEstadoTitularArrendatario | null>>;
}

function TitularArrendatarioListaProcessos({
  setNovaOperacaoPLG,
  setEdicaoOperacao,
  setIsEdicaoOutrosRegimes,
  estadoTela,
  setEstadoTela,
}: Readonly<ITitularArrendatarioListaProcessosProps>) {
  const ABA_CONCESSAO_LICENCIAMENTO_GUIA = 1;
  const ABA_PLG = 2;

  const [keyNotificacao, setKeyNotificacao] = useState(0);
  const context = useContext(DiefCfemContext);
  const { getDeclaracaoResumoPLGById } = useBackEndRequests();
  const [abaSelecionada, setAbaSelecionada] = useState(ABA_CONCESSAO_LICENCIAMENTO_GUIA);

  useEffect(() => {
    const estadoSession = titularArrendatarioEstadoProcesso.carregarEstado();

    setEstadoTela(estadoSession);

    if (estadoSession) {
      if (estadoSession.telaSelecionada === ETabTitularArrendatario.LAVRA_GARIMPEIRA) {
        setAbaSelecionada(ABA_PLG);
      } else if (
        estadoSession.telaSelecionada === ETabTitularArrendatario.OUTROS_REGIMES_CONFIGURACAO ||
        estadoSession.telaSelecionada === ETabTitularArrendatario.OUTROS_REGIMES_LISTAGEM
      ) {
        setAbaSelecionada(ABA_CONCESSAO_LICENCIAMENTO_GUIA);
      }
    }
  }, []);

  useEffect(() => {
    if (context?.errosValidacaoDeclaracao?.tabNContent && context.errosValidacaoDeclaracao.tabNContent.length > 0) {
      const validarOperacoes = async () => {
        if (!context?.declaracaoTitularArrendatario.id) {
          return;
        }
        await getDeclaracaoResumoPLGById(context.declaracaoTitularArrendatario.id)
          .then(() => {
            context?.setErrosValidacaoDeclaracao({ tabNContent: [], showContainer: false });
          })
          .catch((err) => {
            if (err.response.status === 422) {
              const tabNContent = listarErrosValidacao(err.response.data.detail);
              context?.setErrosValidacaoDeclaracao({
                tabNContent: tabNContent,
                showContainer: true,
              });
              setKeyNotificacao((prevKey) => prevKey + 1);
            }
          });
      };
      validarOperacoes();
    }
  }, []);

  const onTabChange = (tab: number) => {
    let abaSelecionada = ETabTitularArrendatario.LAVRA_GARIMPEIRA;

    if (tab === ABA_CONCESSAO_LICENCIAMENTO_GUIA) {
      abaSelecionada = ETabTitularArrendatario.OUTROS_REGIMES_CONFIGURACAO;
    } else if (tab === ABA_PLG) {
      abaSelecionada = ETabTitularArrendatario.LAVRA_GARIMPEIRA;
    }

    const novoEstado = {
      telaSelecionada: abaSelecionada,
    };

    setEstadoTela(novoEstado);
  };

  return (
    <div className={styles.containerPrincipal}>
      <div className={styles.cabecalho}>
        <div className={styles.titleContainer}>
          <h4 className={styles.title}>Processos Minerários</h4>
        </div>
        <div className={styles.botoes}>
          <div className={styles.botao}></div>
        </div>
      </div>
      <Tab
        id='regimesTab'
        className={styles.customTab}
        current={abaSelecionada}
        onTabChange={(currentTab) => onTabChange(currentTab)}
      >
        <Tab.Content
          id='concessaoLicenciamentoGuiaTab'
          title='Concessão/Licenciamento/Guia de Utilização'
          className={styles.tabOutrosRegimes}
        >
          <OutrosRegimesTab
            setIsEdicaoOutrosRegimes={setIsEdicaoOutrosRegimes}
            estadoTela={estadoTela}
            setEstadoTela={setEstadoTela}
          />
        </Tab.Content>
        <Tab.Content title='Permissão de Lavra Garimpeira'>
          <LavraGarimpeiraTab setEdicaoOperacao={setEdicaoOperacao} setNovaOperacaoPLG={setNovaOperacaoPLG} />
        </Tab.Content>
      </Tab>
      <AnmNotificacaoContainer
        key={keyNotificacao}
        title='Pendências da declaração'
        tabNContent={context?.errosValidacaoDeclaracao ? context.errosValidacaoDeclaracao.tabNContent : []}
        showContainer={context?.errosValidacaoDeclaracao?.showContainer ?? false}
        setErrosValidacao={context?.setErrosValidacaoDeclaracao ?? (() => {})}
      />
    </div>
  );
}

export default TitularArrendatarioListaProcessos;
